import { type AnalyticsEvent } from '~/types/analyticsEvents'
import { type UserProfile } from '~/types/user'

let braze: typeof import('@braze/web-sdk') | null = null

let brazeApiKey: string
let brazeSdkEndpoint: string

const ANALYTIC_EVENT_WHITELIST = [
  'account_register_success',
  'bonus_club_show',
  'iap_purchase_start',
  'tracking_finish',
  'profile_show'
]

export const useBrazeTrackingService = () => {
  function setUser(user: UserProfile) {
    if (import.meta.server || !braze) {
      return
    }

    if (!braze.isInitialized) {
      console.warn('Braze is not initialized')
      return
    }

    braze.changeUser(user.id.toString())

    braze.openSession()
  }

  function setApiKey(key: string) {
    brazeApiKey = key
  }

  function setSdkEndpoint(endpoint: string) {
    brazeSdkEndpoint = endpoint
  }

  async function init() {
    if (import.meta.server) {
      return
    }

    if (!braze) {
      braze = await import('@braze/web-sdk')
    }

    if (!brazeApiKey || !brazeSdkEndpoint) {
      console.warn('Braze api key or sdk endpoint is not set')
      return
    }

    braze.initialize(brazeApiKey, {
      baseUrl: brazeSdkEndpoint,
      enableLogging: true,
      allowUserSuppliedJavascript: true,
      inAppMessageZIndex: 9999
    })

    braze.automaticallyShowInAppMessages()
  }

  function trackEvent(args: AnalyticsEvent) {
    if (import.meta.server || !braze) {
      return false
    }

    if (!braze.isInitialized) {
      console.warn('Braze is not initialized')

      return false
    }

    if (!ANALYTIC_EVENT_WHITELIST.includes(args[0])) {
      console.info('Braze event not whitelisted', args[0])

      return false
    }

    if (!braze.getUser()?.getUserId()) {
      console.warn('Braze event tracked without user id')
    }

    braze.logCustomEvent(args[0], args[1])

    return true
  }

  return {
    setUser,
    setApiKey,
    setSdkEndpoint,
    init,
    trackEvent
  }
}
